var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isInitialized
    ? _c(
        "div",
        [
          _vm.hasConversations
            ? _c(
                "div",
                { staticClass: "alert alert-info", attrs: { role: "alert" } },
                [_vm._v("\n    " + _vm._s(_vm.estimateMessage) + "\n  ")]
              )
            : !_vm.hasConversations
            ? _c(
                "div",
                {
                  staticClass: "alert alert-warning",
                  attrs: { role: "alert" },
                },
                [_vm._v("\n    No messages will be sent.\n  ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasExceptions
            ? _c("exception-list", {
                staticClass: "alert alert-warning",
                attrs: { items: _vm.exceptions, role: "alert" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n    Send List: "),
            _c("strong", [_vm._v(_vm._s(_vm.sendListName))]),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isBusy,
                  expression: "isBusy",
                },
              ],
              ref: "form",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "subject", label: "Subject" } },
                [
                  _c("el-input", {
                    ref: "subject",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c(
                                "email-placeholder",
                                { on: { select: _vm.addPlaceholderToSubject } },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "Placeholders",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "color--prpl cursor-pointer",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-code",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3848005271
                    ),
                    model: {
                      value: _vm.form.subject,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "subject", $$v)
                      },
                      expression: "form.subject",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "html_body", label: "Content" } },
                [
                  _c(
                    "div",
                    { staticClass: "d-inline-block w-100" },
                    [
                      _c("tinymce-editor", {
                        ref: "htmlBody",
                        model: {
                          value: _vm.form.html_body,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "html_body", $$v)
                          },
                          expression: "form.html_body",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "email-placeholder",
                    { on: { select: _vm.addPlaceholderToBody } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: { content: "Placeholders", placement: "top" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "text-purple cursor-pointer" },
                            [_c("i", { staticClass: "fas fa-code" })]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-collapse",
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { title: "Schedule an email", name: "schedule" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "start_at", label: "Start" } },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetime",
                                      format: _vm.dateFormat,
                                      "value-format": _vm.formDateFormat,
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.start_at,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "start_at", $$v)
                                      },
                                      expression: "form.start_at",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "stop_at", label: "Stop" } },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetime",
                                      format: _vm.dateFormat,
                                      "value-format": _vm.formDateFormat,
                                      clearable: "",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.form.stop_at,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "stop_at", $$v)
                                      },
                                      expression: "form.stop_at",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: "Follow up text message",
                        name: "follow-up-text",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Delay" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.follow_up_delay,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "follow_up_delay", $$v)
                                },
                                expression: "form.follow_up_delay",
                              },
                            },
                            _vm._l(
                              _vm.followUpMessageProps.delayOptions,
                              function ({ value, label }) {
                                return _c("el-option", {
                                  key: value,
                                  attrs: { value: value, label: label },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mb-0",
                          attrs: { prop: "follow_up_message" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "el-form-item__label text-left line-height-15",
                                  attrs: { for: "follow-up-message-control" },
                                },
                                [_vm._v("Message")]
                              ),
                              _vm._v(" "),
                              _c("follow-up-message-control", {
                                attrs: {
                                  "approved-message-list-url":
                                    _vm.followUpMessageProps
                                      .approvedMessageListUrl,
                                  "can-send-sms":
                                    _vm.followUpMessageProps.can.sendSms,
                                  "can-send-approved-sms":
                                    _vm.followUpMessageProps.can
                                      .sendApprovedSms,
                                  id: "follow-up-message-control",
                                },
                                model: {
                                  value: _vm.form.follow_up_message,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "follow_up_message", $$v)
                                  },
                                  expression: "form.follow_up_message",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "throttle", label: "Throttle" } },
                [
                  _c("el-switch", {
                    attrs: { "active-color": "#3d3a7f" },
                    model: {
                      value: _vm.form.throttle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "throttle", $$v)
                      },
                      expression: "form.throttle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary px-4",
                    attrs: { disabled: _vm.isSentButtonDisabled },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.save.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Send")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }